module.exports = __webpack_public_path__ + "assets/distance-driven.d4a0a98b.svg";